import { PhaserGamePad } from "src/games/shared/Gamepad";
import bindAllOfThis from "src/utils/BindThisHelper";
import { UpdateScene } from "./UpdateScene";

export class EventScene extends Phaser.Scene {
    private initialized: boolean = false;
    private player: Phaser.Physics.Arcade.Image;
    private speed: number = 100;
    private generalSize: number = 64;
    private gamePad: PhaserGamePad;
    private xVel: number = 0;
    private yVel: number = 0;

    constructor() {
        super({
            key: "EventScene"
        });
    }

    init(data: Phaser.Geom.Rectangle) {
        console.warn("Running Init", EventScene.name, data); // JB - Remove this console.warn
        // this.scene.restart();
        if (data != null && this.initialized) {
            this.player.setPosition(data.x, data.y);
        }
    }

    preload(): void {
        this.load.image("background", require("/src/assets/qci/backgrounds/planet_r_top.jpg"));
        this.load.image("player", require("/src/assets/games/coinRunner/player.png"));
        this.load.image("pixel", require("/src/assets/qci/sprites/pixel.png"));

        PhaserGamePad.preload(this);
    }

    create(): void {
        if (this.initialized) {
            return;
        }
        bindAllOfThis(this, EventScene.prototype);

        this.input.addPointer(6);
        this.gamePad = new PhaserGamePad(this);

        this.createObjects();
        this.bindEvents();
        this.initialized = true;
    }

    createObjects() {
        let blackground = this.add.image(0, 0, "background")
            .setOrigin(0)
            .setTint(0xddffdd);
        let overlay = this.add.text(16, 16, "This demo uses an event driven approach to moving the player around", {
            fontSize: '24px',
            fill: '#ffffff'
        });
        let switcherButton = this.add.image(this.sys.canvas.width - 128 - 16, 16, "pixel");
        switcherButton.setTint(0x003355);
        switcherButton.setDisplaySize(128, 64);
        switcherButton.setInteractive();
        switcherButton.setDepth(2);
        switcherButton.on("pointerdown", () => {
            this.scene.remove(this);
            // GameState.current = new GameState();
            // var nextSceneObject = Helpers.getNextScene(GameState.current.sceneNumber);
            // GameState.current.sceneNumber += 1;
            this.scene.remove(this);
            this.scene.add("UpdateScene", UpdateScene, true);

            // this.scene.switch(UpdateScene.name);
            // this.scene.setActive(false, "BaseScene");
            // this.scene.setVisible(false, "BaseScene");
            // this.scene.start(UpdateScene.name, new Phaser.Geom.Rectangle(this.player.x, this.player.y));
            // this.scene.pause(EventScene.name);
        });
        let buttonText = this.add.text(switcherButton.x, switcherButton.y, "Flip!", {
            fontSize: '16px',
            fill: '#ffffff'
        });
        buttonText.setDepth(2);
        Phaser.Display.Align.In.Center(buttonText, switcherButton);

        this.player = this.physics.add.image(this.sys.canvas.width / 2, this.sys.canvas.height / 2, "player");
        this.player.setOrigin(.5);
        this.player.setDisplaySize(this.generalSize, this.generalSize);

        // START DEBUG CODE
        // let coolPlayer = this.physics.add.image((this.sys.canvas.width / 2) + 90, (this.sys.canvas.height / 2), "player");
        // coolPlayer.setOrigin(.5);
        // coolPlayer.setDisplaySize(this.generalSize, this.generalSize);
        // coolPlayer.setInteractive();

        // this.input.keyboard.on("keydown_L", (a, b, c, d) => {
        //     console.warn("Getting A", a, b, c, d); // JB - Remove this console.warn
        // });
        // this.input.keyboard.on("keydown_J", (a, b, c, d) => {
        //     console.warn("Getting J", a, b, c, d); // JB - Remove this console.warn
        // });

        // this.player.setInteractive();
        // this.player.on("pointerdown", (a, b, c) => {
        //     console.warn("pointer down on player", a, b, c);
        // });
        // coolPlayer.on("pointerdown", (a, b, c) => {
        //     console.warn("pointer down on coolPlayer", a, b, c);
        // });
        // this.input.on("pointerup", (a: Phaser.Input.Pointer, b, c) => {
        //     console.warn("pointerup on input", a, b, c);
        // });
        // this.player.on("pointerup", (a, b, c) => {
        //     console.warn("pointerup on player", a, b, c);
        // });
        // coolPlayer.on("pointerup", (a, b, c) => {
        //     console.warn("pointerup on coolPlayer", a, b, c);
        // });
        // END DEBUG CODE
    }

    bindEvents() {
        this.gamePad.on("keydown_up", this.moveUpStart);
        this.gamePad.on("keydown_down", this.moveDownStart);
        this.gamePad.on("keydown_left", this.moveLeftStart);
        this.gamePad.on("keydown_right", this.moveRightStart);
        this.gamePad.on("keydown_a", this.aDownStart);
        this.gamePad.on("keydown_b", this.bDownStart);

        this.gamePad.on("keyup_up", this.moveUpStop);
        this.gamePad.on("keyup_down", this.moveDownStop);
        this.gamePad.on("keyup_left", this.moveLeftStop);
        this.gamePad.on("keyup_right", this.moveRightStop);
        this.gamePad.on("keyup_a", this.stopAB);
        this.gamePad.on("keyup_b", this.stopAB);
    }

    moveUpStart() {
        console.warn("Move up Received in scene"); // JB - Remove this console.warn
        this.yVel += -this.speed;
        this.updateVelocity();
    }
    moveDownStart() {
        this.yVel += this.speed;
        this.updateVelocity();
    }
    moveLeftStart() {
        this.xVel += -this.speed;
        this.updateVelocity();
    }
    moveRightStart() {
        this.xVel += this.speed;
        this.updateVelocity();
    }

    moveUpStop() {
        this.yVel -= -this.speed;
        this.updateVelocity();
    }
    moveDownStop() {
        this.yVel -= this.speed;
        this.updateVelocity();
    }
    moveLeftStop() {
        this.xVel -= -this.speed;
        this.updateVelocity();
    }
    moveRightStop() {
        this.xVel -= this.speed;
        this.updateVelocity();
    }

    aDownStart() {
        // this.player.setDisplaySize(this.generalSize / 2, this.generalSize / 2);
        this.updateVelocity();
    }
    bDownStart() {
        // this.player.setDisplaySize(this.generalSize * 3, this.generalSize * 3);
        this.updateVelocity();
    }
    stopAB() {
        // this.player.setDisplaySize(this.generalSize, this.generalSize);
        this.updateVelocity();
    }

    updateVelocity() {
        console.log('updating in event scene');
        var scale: number = 1;
        if (this.gamePad.keys.a.isDown) {
            scale = .5;
        } else if (this.gamePad.keys.b.isDown) {
            scale = 3;
        }

        this.player.setDisplaySize(this.generalSize * scale, this.generalSize * scale);
        this.player.setVelocity(this.xVel * scale, this.yVel * scale);

        // Get flip
        if (this.xVel !== 0 && (this.gamePad.keys.left.isDown || this.gamePad.keys.right.isDown)) {
            this.player.setFlipX(this.xVel < 0);
        }
    }

    update(): void {
        // NOOP
    }
}



// WEBPACK FOOTER //
// ./src/games/demos/phaserGamePadDemo/scenes/EventScene.ts